import { BackupHandlers, BackupMap, BackupReq } from './backup.slice';

export const createBackup = <H extends BackupHandlers>(handler: H, payload: BackupReq<H>, data: BackupMap[H]) => {
  return {
    handler,
    data,
    params: payload.backupParams,
  };
};
